const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const commentForm = {
	$author: $('#author'),
	$review: $('#comment'),
	$email: $('#email'),
	$domCommentAuthor: $('.comment-form-author'),
	$domCommentReview: $('.comment-form-comment'),
	$domCommentEmail: $('.comment-form-email'),
	// submit: $('.js-comment-submit'),
	$submit: $('.form-submit .submit'),
	$domUser: $('.js-comments'),

	init: function() {
		this.checkForm();
		this.enterValue();
	},
	checkForm: function() {
		commentForm.$submit.on('click', (event)=>{
			const user = commentForm.$domUser.attr('data-key');
			if (parseInt(user) !== 0) {
				if(!commentForm.$review.val().trim()) {
					$('.js-review-message').remove();
					commentForm.$domCommentReview.append('<span class="reviews-error-msg js-review-message">Please enter your review</span>');
					return false;
				}
			} else {
				// eslint-disable-next-line no-mixed-spaces-and-tabs
				if(!commentForm.$review.val().trim()) {
					$('.js-review-message').remove();
					commentForm.$domCommentReview.append('<span class="reviews-error-msg js-review-message">Please enter your review</span>');
					return false;
				} if(!commentForm.$author.val()) {
					$('.js-author-message').remove();
					commentForm.$domCommentAuthor.append('<span class="reviews-error-msg js-author-message">Please enter your name</span>');
					return false;
				} if(!commentForm.$email.val()) {
					$('.js-email-message').remove();
					commentForm.$domCommentEmail.append('<span class="reviews-error-msg js-email-message">Please enter your email</span>');
					return false;
				} if(commentForm.IsEmail(commentForm.$email.val()) === false) {
					$('.js-email-message').remove();
					$('.js-valid-email-message').remove();
					commentForm.$domCommentEmail.append('<span class="reviews-error-msg js-valid-email-message">Email address is not valid</span>');
					return false;
				}if(commentForm.$review.val() && commentForm.$author.val() && commentForm.$email.val() && commentForm.IsEmail(commentForm.$email.val()) === true){
					$('.js-review-message').remove();
					$('.js-author-message').remove();
					$('.js-email-message').remove();
					$('.js-valid-email-message').remove();
				}
			}
		});
	},
	IsEmail: function(email) {
		let regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
		if(!regex.test(email)) {
			return false;
		}else{
			return true;
		}
	},
	enterValue: function(){
		commentForm.$review.on('keyup', ()=> {
			if (commentForm.$review.val().length > 0){
				$('.js-review-message').remove();
			}else{
				$('.js-review-message').remove();
				commentForm.$domCommentReview.append('<span class="reviews-error-msg js-review-message">Please enter your review</span>');
			}
		});
		commentForm.$author.on('keyup', ()=> {
			if (commentForm.$author.val().length > 0){
				$('.js-author-message').remove();
			}else{
				$('.js-author-message').remove();
				commentForm.$domCommentAuthor.append('<span class="reviews-error-msg js-author-message">Please enter your name</span>');
			}
		});
		commentForm.$email.on('keyup', ()=> {
			if (commentForm.$email.val().length > 0){
				$('.js-email-message').remove();
				$('.js-valid-email-message').remove();
			}else{
				$('.js-email-message').remove();
				$('.js-valid-email-message').remove();
				commentForm.$domCommentEmail.append('<span class="reviews-error-msg js-email-message">Please enter your email</span>');
			}
		});
	},
};

export default commentForm;
